export class TvBar {
    constructor() {
        this.time = 0;
        this.volume = 0;
        this.open = 0;
        this.close = 0;
        this.high = 0;
        this.low = 0;
        this.date = new Date(); // for help with debugging
    }
}
